import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

type SwitchParams = {
  defaultChecked: boolean;
  params: {
    func: any;
    funcParams: any;
  };
  updateFront: any;
  className?: string;
};

export const ComponentSwitchToggleStatus = ({
  defaultChecked,
  params,
  updateFront,
  className,
}: SwitchParams) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [animateError, setAnimateError] = useState("");

  const handleChecked = async () => {
    setIsDisabled((prev) => !prev);
    const { ok } = await params.func(params.funcParams);
    if (!ok) {
      setAnimateError("animate-shake");
      return setIsDisabled((prev) => !prev);
    }

    setIsDisabled((prev) => !prev);
    updateFront();
  };

  useEffect(() => {
    if (animateError === "animate-shake")
      (async () => {
        await new Promise((resolve) => setTimeout(resolve, 500));
        setAnimateError("");
      })();
  }, [animateError]);

  return (
    <div
      className={cn(
        `flex items-center justify-center ${animateError}`,
        className
      )}
    >
      <Switch
        checked={defaultChecked}
        onCheckedChange={handleChecked}
        disabled={isDisabled}
      />
    </div>
  );
};
